import comp from "./Question";
export default comp;
